export enum SmallTexts {
  Snitem = 'SNITEM. Innovation en plaies & cicatrisation. 2021',
  Has = 'HAS. Les pansements – Indications et utilisations recommandées. 2010',
  Carrera = 'Carrera R. Mésothérapie&nbsp;: traitement complémentaire de la chirurgie&nbsp;? 2006-2007',
  Chru = 'CHRU de Brest. Aide au bon usage des pansements en sortie d’hospitalisation. Janvier 2020',
  Amici = 'Amici JM. « La cicatrisation de la peau ». Dermato-info.fr. Consulté le 25/06/2024',
  Chuv = 'CHUV. Recommandations - La plaie. 2018',
  PriseEnCharge = 'Prise en charge pharmaceutique des plaies chroniques&nbsp;: coopération ville-hôpital à' +
    ' développer&nbsp?<br/>Communication Journées Europharmat 2019',
  WorldUnion = 'World Union of Wound Healing Societies (WUWHS). Principles of best practice: Wound exudate and the' +
    ' role of dressings. A consensus document. London: MEP Ltd, 2007',
  NumSpecLohmann = 'Numéro spécial Lohmann & Rauscher – L’infirmière libérale – Janvier 2017 (page 9)',
  NicholsEWoundAssess = 'Nichols E. Wound Assessment Part 2&nbsp;: Exsudate. Wound Essentials 2016, Vol 11 No 1',
  Graphe2 = 'Graphe&nbsp;: 2. Journal des plaies et cicatrisation N°9 Septembre 1997 SFFPC – Illustrations réalisées en interne',
  EffectAirDrying = '«Effect of Air Drying and Dressings on the Surface of a Wound». Winter GD, Nature, 1963;' +
    ' 197:92-93',
  SenetP = 'Senet P. Les pansements. SFD. Dermato-info.fr. Consulté le 25/06/2024',
  Sfar = 'SFAR. Quelle antisepsie pour la peau saine&nbsp;? Mis en ligne le 22/10/2013. Disponible sur&nbsp;:' +
    ' <a href="https://sfar.org/quelle-antisepsie-pour-la-peau-saine"' +
    ' target="_blank">https://sfar.org/quelle-antisepsie-pour-la-peau-saine</a>&nbsp;; Consulté le 12/08/2024',
  Codims = 'Recommandations CODIMS – AP-HP. Bon usage des pansements pour la cicatrisation. Mai 2022',
  ColauH = 'Colau H. et Dell’Angela C. Quel pansement pour quelle plaie&nbsp;? L’infirmière magazine&nbsp;; Hors-Série n°370' +
    ' du 01/04/2016.<br/>' +
    'Disponible sur&nbsp;: <a' +
    ' href="https://www.espaceinfirmier.fr/presse/l-infirmiere-magazine/article/n-370_hs/quel-pansement-pour-quelle-plaie-IMHS37002501.html" target="_blank">https://www.espaceinfirmier.fr/presse/l-infirmiere-magazine/article/n-370_hs/quel-pansement-pour-quelle-plaie-IMHS37002501.html</a>&nbsp;; Consulté le 12/08/2024.',
  //Photo216489892 = 'Photo Adobe Stock, N°216489892',
  AssuranceMaladie = 'Assurance Maladie. Reconnaître une ampoule ou une cloque. 19 juin 2024. Disponible sur' +
    '  <a href="https://www.ameli.fr/assure/sante/themes/ampoules-cloques/reconnaitre-ampoule-cloque"' +
    ' target="_blank">https://www.ameli.fr/assure/sante/themes/ampoules-cloques/reconnaitre-ampoule-cloque</a>&nbsp;;' +
    ' consulté le 26/04/2024.',
  PikovskiD = 'Pikovski D. Phlyctène (coque, ampoule)&nbsp;: définition, soins, traitements. Disponible sur&nbsp;:' +
    ' <a href="https://docteur-picovski.com/lexique/phlyctene-ampoule"' +
    ' target=_blank">https://docteur-picovski.com/lexique/phlyctene-ampoule</a>&nbsp;; consulté le 26/04/2024.',
  DFC2019066 = 'DFC-2019-066',
  DFC2019068 = 'DFC-2019-068',
  DFC2019070 = 'DFC-2019-070',
  DFC2019071 = 'DFC-2019-071',
  DFC2019112 = 'DFC-2019-112',
  DFC2019125 = 'DFC-2019-125',
  DFC2020036 = 'DFC-2020-036',
  DFC2021108 = 'DFC-2021-108',
  DFC2021111 = 'DFC-2021-111',
  DFC2021112 = 'DFC-2021-112',
  DFC2021113 = 'DFC-2021-113',
  DFC2021114 = 'DFC-2021-114',
  DFC2021116 = 'DFC-2021-116',
  DFC2021118 = 'DFC-2021-118',
  DFC2021119 = 'DFC-2021-119',
  DFC2021121 = 'DFC-2021-121',
  DFC2021123 = 'DFC-2021-123',
  DFC2022041 = 'DFC-2022-041',
  DFC2022045 = 'DFC-2022-045',
  DFC2022046 = 'DFC-2022-046',
  DFC2022043 = 'DFC-2022-043',
  DFC2022048 = 'DFC-2022-048',
  DFC2022049 = 'DFC-2022-049',
  DFC2022050 = 'DFC-2022-050',
  DFC2022051 = 'DFC-2022-051',
  DFC2022053 = 'DFC-2022-053',
  DFC2022054 = 'DFC-2022-054',
  DFC2024062 = 'DFC-2024-062',
  DFC2024063 = 'DFC-2024-063',
  DFC2024154 = 'DFC-2024-154',
  NoticeUtilisation = 'Notice d’utilisation',
  VliwasorbSensitive = 'Vliwasorb<sup>®</sup> sensitive',
  VliwasorbPro = 'Vliwasorb<sup>®</sup> Pro',
  NoticesUtilisation = 'Notices d’utilisation',
  BestPractice = 'Best practice statement: care of the person with diabetes and lower limb ulcers',
  LomigLeBihan = 'Lomig Le Bihan, Amélie Chopin, Dr. Durufle, Dr. Robineau, Les ulcères de jambe, du diagnostic au' +
    ' traitement, ActuSoins Magazine n° 33, 06/07/08 2019',
  HopitalParisSaintJoseph = 'Hôpital Paris Saint-Joseph. Ulcère de jambe. Octobre 2022. Disponible sur&nbsp;:' +
    ' <a href="https://www.hpsj.fr/specialites/medecinevasculaire-' +
    'phlebologie/pathologies/ulceres-de-jambe" target="_blank">https://www.hpsj.fr/specialites/medecinevasculaire-' +
    'phlebologie/pathologies/ulceres-de-jambe</a>&nbsp;; Consulté le 22/07/2024',
  HospicesCivilsLyon = 'Hospices Civils de Lyon. Ulcère cutané. 10.08.2021&nbsp;; Disponible sur&nbsp;: <a' +
    ' href="https://www.chu-lyon.fr/ulcere-cutane" target="_blank">https://www.chu-lyon.fr/ulcere-cutane</a>&nbsp;; Consulté le' +
    ' 22/07/2024',
  OuvryPierre = 'Ouvry, Pierre. (2017). Les ulcères veineux&nbsp;: bilan diagnostique et options thérapeutiques. Revue Francophone de Cicatrisation, 1(4), 28–33.',
  HasPriseEnCharge = "HAS. Prise en charge de l'ulcère de jambe à prédominance veineuse hors pansement. Synthèse des" +
    " recommandations. Juin 2006",
  UlcereJambe = 'Ulcère de jambe. Complications de l’ulcère. Disponible sur&nbsp;:' +
    ' <a href="https://www.ulcere-de-jambe.com/plaie/complications-ulcere"' +
    ' target="_blank">https://www.ulcere-de-jambe.com/plaie/complications-ulcere/</a>&nbsp;; ' +
    'Consulté le 23/07/2024',
  WoundsUk = 'Wounds UK. Best Practice Statement&nbsp;: Care of the person with diabetes and lower limb ulcers. 2021',
  MalacarneS = 'Malacarne S. et al. Importance de la décharge dans le traitement des lésions du pied diabétique. Rev' +
    ' Med Suisse 2011&nbsp;; 7&nbsp;: 1267-72',
  AkkusG = 'Akkus G, Sert M. Diabetic foot ulcers: A devastating complication of diabetes mellitus continues' +
    ' non-stop in spite of new medical treatment modalities. World J Diabetes. 2022 Dec 15;13(12):1106-1121.',
  AMPlaiesChroniques = 'AM. Plaies chroniques&nbsp;: prise en charge en ville. Octobre 2015',
  HasBonUsage = 'HAS. Bon usage des technologies de santé&nbsp;: la compression médicale dans les affections veineuses chroniques. Décembre 2010',
  WongIky = 'Wong I.K.Y. et al. Randomized controlled trial comparing treatment outcome of two compression bandaging' +
    ' systems and standard care without compression in patients with venous leg ulcers. J Eur Acad Dermatol' +
    ' Venereol. 2012 Jan;26(1):102-10.',
  AMAmaigrissement  = 'AM. Amaigrissement et dénutrition&nbsp;: comment y remédier&nbsp;? 18/04/23 Disponible' +
    ' sur&nbsp;:' +
    ' <a target="_blank"' +
    ' href="https://www.ameli.fr/paris/assure/sante/themes/amaigrissement-et-denutrition/amaigrissement-et-denutrition-comment-y-remedier">https://www.ameli.fr/paris/assure/sante/themes/amaigrissement-et-denutrition/amaigrissement-et-denutrition-comment-y-remedier</a>&nbsp;; Consulté le 12/08/2024',
}
